import { Icon } from '@iconify/react';
import AnimatedSection from '../components/ui/AnimatedSection';
import PageBanner from '../components/layout/PageBanner';

export default function CambiarContrasena(){
    return(
        <main className="bg-[#f5f5f7] text-[#2d2d44]">
            <PageBanner
              titulo="Cambiar contraseña"
              crumbs={[
                { label: 'Inicio', href: '/' },
                { label: 'Cambiar contraseña' },
              ]}
            />
            <div className="max-w-4xl mx-auto px-4 py-12">
                <AnimatedSection className="max-w-md mx-auto">
                    <div className="bg-white border border-black/10 rounded-2xl p-8 space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1.5">Contraseña actual</label>
                            <input type="password" className="w-full px-4 py-3 border border-black/10 rounded-xl text-sm focus:outline-none focus:border-[#f26724] focus:ring-1 focus:ring-[#f26724]/20 transition-colors" placeholder="Ingresa tu contraseña actual" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1.5">Nueva contraseña</label>
                            <input type="password" className="w-full px-4 py-3 border border-black/10 rounded-xl text-sm focus:outline-none focus:border-[#f26724] focus:ring-1 focus:ring-[#f26724]/20 transition-colors" placeholder="Ingresa tu nueva contraseña" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1.5">Confirmar nueva contraseña</label>
                            <input type="password" className="w-full px-4 py-3 border border-black/10 rounded-xl text-sm focus:outline-none focus:border-[#f26724] focus:ring-1 focus:ring-[#f26724]/20 transition-colors" placeholder="Repite la nueva contraseña" />
                        </div>
                        <button className="w-full px-6 py-3 bg-[#f26724] text-black font-semibold rounded-xl hover:bg-[#f3823c] transition-all hover:shadow-lg hover:shadow-[#f26724]/20">
                            Guardar cambios
                        </button>
                    </div>
                </AnimatedSection>
            </div>
        </main>
    )
}
